import type { ReactNode } from 'react';
import { FilterListAtomProvider } from './filterList/FilterListAtomProvider';
import { FilterListBottomSheetAtomProvider } from './filterListBottomSheet/FilterListBottomSheetAtomProvider';

export const FilterListAtomicProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  return (
    <FilterListAtomProvider>
      <FilterListBottomSheetAtomProvider>
        {children}
      </FilterListBottomSheetAtomProvider>
    </FilterListAtomProvider>
  );
};
